import React, { useState } from 'react';
import { Button } from '../../../../../ui/components/Button';
import UnileverImportScanModal from './models/UnileverImportScanModal';
import { Order } from '../../../../order';

interface UnileverImportScanButtonProps {
  order: Order;
}

export default function UnileverImportScanButton({ order }: UnileverImportScanButtonProps) {
  const [open, setOpen] = useState(false);

  const handleUnileverImport = () => {
    setOpen(true);
  };

  return (
    <>
      {open && <UnileverImportScanModal open={open} setOpen={setOpen} order={order} />}
      <Button text='Import Scan File' onClick={handleUnileverImport} />
    </>
  );
}
